import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import swal from 'sweetalert2';
import {Router} from '@angular/router';
import {ApiService,StrongPasswordRegx} from '../../service/api.service';
import {Subject} from 'rxjs';
import { HelperService } from '../../service/helper.service';
import {TranslateService} from "@ngx-translate/core";
import {CustomPasswordValidator} from '../../store/custom-password-validator'


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  hide = true;
  hide_1 = true;

  resetPasswordForm: FormGroup;
  private destroy$ = new Subject();

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private Api: ApiService,
              // private Helper: HelperService,
              private translate: TranslateService) {
    this.resetPasswordForm = this.formBuilder.group({
        otp: [null, [Validators.required, Validators.minLength(6),HelperService.noWhitespaceValidator,Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
        password: ['', [Validators.required, Validators.pattern(StrongPasswordRegx)]],
        confirmPassword: [null, [Validators.required]]
      },
      {validator: this.ConfirmedValidator('password', 'confirmPassword')}
    );
  }

  ngOnInit(): void {
  }

  get password() {
    return this.resetPasswordForm.get('password');
  }

  get confpassword() {
    return this.resetPasswordForm.get('confirmPassword');
  }

  onSubmit(): void {
    const userEmail= JSON.parse(localStorage.getItem("setEmailforgot")) 
    const payLoadBody = {
      "email" :userEmail,
      "otp" : this.resetPasswordForm.controls['otp'].value ? this.resetPasswordForm.controls['otp'].value : '',
      "password" : this.resetPasswordForm.controls['confirmPassword'].value ? this.resetPasswordForm.controls['confirmPassword'].value : '',
    }
    if (this.resetPasswordForm.valid) {
      this.Api.resetPassword(payLoadBody)
        .pipe(takeUntil(this.destroy$))
        .subscribe( (data) => {
          if(data.result){
            this.router.navigate(['/']);
            swal.fire(
              '',
              this.translate.instant(data.message),
              'success'
            );       
          }else{
            swal.fire(
              '',
              this.translate.instant(data.message),
              'info'
            ); 
          }
 
        }, (error) => {
          const e = error.error;
          swal.fire(
            '',
            this.translate.instant(e.message),
            'error'
          );
        });
    }
  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors['confirmedValidator']) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }


  ngOnDestroy(): void {
    this.destroy$.next();  // trigger the unsubscribe
    this.destroy$.complete(); // finalize & clean up the subject stream
  }
  public space(event:any) {
    if (event.target.selectionStart === 0 && event.code === 'Space'){
      event.preventDefault();
    }
  }

  resendOTP() {
    const userEmail = JSON.parse(localStorage.getItem("setEmailforgot"))
    this.Api.forgotPassword({ email: userEmail }).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data.data.isEmailSent) {
        swal.fire(
          '',
          this.translate.instant('otp_resent'),
          'success'
        );
        this.router.navigate(['reset-password']);
      } else {
        swal.fire(
          '',
          this.translate.instant('RESETPASSWORDFORM.Unauthorized_User'),
          'error'
        );
      }
    }, (error) => {
      const e = error.error;
      swal.fire(
        '',
        this.translate.instant(e.message),
        'info'
      );
    });
  }
}
